// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kx-c";
export var backButton = "_kx-4";
export var backIcon = "_kx-5";
export var chevronShortcut = "_kx-6";
export var container = "_kx-1";
export var editor = "_kx-8";
export var editorWrapper = "_kx-7";
export var prefix = "_kx-2";
export var searchIcon = "_kx-3";
export var suffix = "_kx-9";
export var suffixContent = "_kx-a";
export var suffixText = "_kx-b";
export var wrapper = "_kx-0";